export const JETTY_URL = process.env.REACT_APP_JETTY_URL
